function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-regard");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-regard"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(3.000000, 3.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 24,
  height: 24
})), /*#__PURE__*/React.createElement("path", {
  d: "M27,3 L27,27 L3,27 L3,3 L27,3 Z M24,6 L6,6 L6,24 L24,24 L24,6 Z",
  id: "Combined-Shape",
  fill: "#000000"
})));

const SvgIco30Regard = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Regard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-regard.0d4ce764.svg";
export { ForwardRef as ReactComponent };